// extracted by mini-css-extract-plugin
export default {"member":"style_member__18YmB","bg":"style_bg__lbAJ4","content":"style_content__fvunO","image":"style_image__XODoH"};